// Constantes globales partagées client et serveur.
// Ce fichier ne doit contenir QUE des valeurs immuables.

export const APP_VERSION = '0.1.0'
export const APP_NAME = 'BD-CosPro'

// Tarification — ABONNEMENT (décision du 10/06 ; modèle « paiement unique / lifetime » abandonné).
// Formule annuelle = 2 mois offerts. Clientes V1 déjà en place : 1 an offert puis abonnement.
export const PRICING = {
  starter: { label: 'Starter', monthlyEur: 15, yearlyEur: 150 },
  premium: { label: 'Premium', monthlyEur: 25, yearlyEur: 250 },
} as const

// Quotas mensuels d'appels à l'API Claude par tier
export const CLAUDE_QUOTAS = {
  trial: 10, // pendant les 15 jours d'essai
  starter: 10,
  premium: 50,
} as const

// Durée de l'essai gratuit (jours)
export const TRIAL_DURATION_DAYS = 15
